import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { SubItem } from '../model/sub-item';

@Injectable({
    providedIn: 'root'
  })
  export class SubItemService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findById(subItemId) {
        return this._restClientService.load<SubItem>('sub-item/find-by-id/'+subItemId);
    }
    
  }